import { IScope, IWindowService } from "angular";
import { BlockConfigurationObject } from "../../interfaces/block-configuration-object.interface";
import { SportDataService } from "../../services/sport-data.service";

import { GeneralService } from "../../services/general.service";
import { Match } from "../../interfaces/match.interface";


export class NewBestPromosController {
	
	// awayBeforeHome = false;
	// bestBetError = false;
	// bestParlayUnavailable = false;
	// betType: string;
	displayMaximumWidths = {
		"x-compact": 350,
		"compact": 500,
		"less-compact": 600,
		"medium": 700,
		"large": 800,
	};
	displayMode = "full";
	// gamesError = false;
	// gamesLoading = true;
	generalService: GeneralService;
	match: Match = null;
	showBestParlay = false;
	_$scope: IScope;
	// _Rollbar: any;
	_$window: IWindowService;
	configurationObject: BlockConfigurationObject;
	sportDataService: SportDataService;

	offersLoading = true;
	offersError = false;
	offers: Record<string, any> = {};
    offerDropdownOpen: boolean[] = [];

	/* @ngInject */
	constructor(
        $scope: IScope, 
        // Rollbar: any, 
        $window: IWindowService, 
        configurationObject: BlockConfigurationObject,
		sportDataService: SportDataService, 
        generalService: GeneralService) {
		this._$scope = $scope;
		// this._Rollbar = Rollbar;
		this._$window = $window;
		this.configurationObject = configurationObject;
		this.sportDataService = sportDataService;
		this.generalService = generalService;

		// this.betType = configurationObject.betType;
		
		generalService.initialiseBlock();

		Object.keys(this.displayMaximumWidths).forEach(level => {
			if ($window.document.getElementById(configurationObject.targetElementID)
				&& $window.document.getElementById(configurationObject.targetElementID).offsetWidth <= this.displayMaximumWidths[level]) {
				this.displayMode += ` ${level}`;
			}
		});

		$window.addEventListener("resize", this.checkCompact);

		this.loadOffers();
		
	}

	checkCompact = (): void => {
		let modeString = "full";
		Object.keys(this.displayMaximumWidths).forEach(level => {
			if (this._$window.document.getElementById(this.configurationObject.targetElementID)
				&& this._$window.document.getElementById(this.configurationObject.targetElementID).offsetWidth <= this.displayMaximumWidths[level]) {
				modeString += ` ${level}`;
			}
		});

		this._$scope.$apply(() => {
			this.displayMode = modeString;
		});
	}
	
	ngOnInit(): void {
		this.loadOffers();
	}

	loadOffers(): void {
		this.offersLoading = true;
		this.offersError = false;

		this.sportDataService.getBestPromosFromCosmic(5, this.configurationObject.clientID)
			.then(offers => {
				this.offers = offers;
				this.offersLoading = false;
			}).catch(() => {
				this.offersError = true;
			});
		
	}
    
    toggleOfferDropdown = (event: MouseEvent, index:number): void => {
        event.stopPropagation();
        this.offerDropdownOpen[index] = !this.offerDropdownOpen[index];
    }
}